import { useQuery } from "@apollo/client";
import { Route, Routes, useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import { WebhooksTierInfo } from "components/TierInfo/WebhooksTierInfo";
import useErrorHandle from "hooks/useErrorHandle";
import { NamedWebhooksIntegration } from "types/generated";

import { GET_NAMED_WEBHOOK_DELIVERY_DETAILS } from "./gql";
import WebhookDeliveryRequest from "./Request";
import useIntegrationsLayout from "./useIntegrationsLayout";

const WebhookDeliveryView = () => {
  const {
    deliveryId,
    integrationId: webhookId,
    statusCode,
  } = useParams<{
    deliveryId: string;
    integrationId: string;
    statusCode: string;
  }>();
  const { error, loading, data } = useQuery<{
    namedWebhooksIntegration: NamedWebhooksIntegration;
  }>(GET_NAMED_WEBHOOK_DELIVERY_DETAILS, {
    variables: {
      id: webhookId,
      key: `${deliveryId}/${statusCode}`,
    },
  });

  useIntegrationsLayout();

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !data) {
    return <PageLoading />;
  }

  if (!data) {
    return <NotFoundPage />;
  }

  return (
    <div>
      <WebhooksTierInfo />
      <Routes>
        <Route
          index
          element={
            <WebhookDeliveryRequest
              headers={data?.namedWebhooksIntegration?.deliveryDetails?.requestHeaders}
              body={data?.namedWebhooksIntegration?.deliveryDetails?.requestBody}
            />
          }
        />
        <Route
          path="response"
          element={
            <WebhookDeliveryRequest
              headers={data?.namedWebhooksIntegration?.deliveryDetails?.responseHeaders}
              body={data?.namedWebhooksIntegration?.deliveryDetails?.responseBody}
              error={data?.namedWebhooksIntegration?.deliveryDetails?.responseError}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default WebhookDeliveryView;
